import { z } from "zod";
import {
  TopolBlockSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";
import { TopolLoopColumnSchema } from "./loopBlockSchema";

export const TopolFeedBlocksSchemas = TopolBlockSchema.extend({
  tagName: z.literal("mj-feed-block"),
  attributes: z.any(),
  layout: z.enum(["image-text", "column", "text-image"]).catch("column"),
  maxPerRow: z.number().min(1).max(4).catch(1),
  mode: z.enum(["static", "dynamic"]).catch("static"),
  forMergeTag: z.string().optional().catch(undefined),
  blockName: z.string(),
  syncButtonText: z.boolean().optional().catch(true),
  items: z.array(z.any()).catch([]),
  children: z.array(TopolLoopColumnSchema).catch([]),
  "button-hover": z
    .object({
      "background-color": TopolColorSchema.optional().catch(undefined),
      color: TopolColorSchema.optional().catch(undefined),
      gradient: TopolColorBearingSchema.optional(),
    })
    .optional(),
});

export type TopolFeedBlock = z.infer<typeof TopolFeedBlocksSchemas>;
